import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { SkeletonComponent } from '../skeleton/skeleton.component';

/**
 * Loading feedback (UHD-1736): the bar and the placeholders. SecuredSharedModule re-exports it; modules that
 * SecuredSharedModule imports itself (DialogModule) or that must not bring its providers import this one.
 */
@NgModule({
  declarations: [LoadingIndicatorComponent, SkeletonComponent],
  imports: [CommonModule, MatProgressBarModule],
  exports: [LoadingIndicatorComponent, SkeletonComponent],
})
export class LoadingModule {}
